namespace Matrix.Workflow {
    export interface QueueRow {
        QueueCode?: string;
        QueueName?: string;
        QueueTypeCode?: string;
        StatusCodes?: string;
        WorkflowCode?: string;
        WorkflowClass1?: string;
        WorkflowClass2?: string;
        WorkflowClass3?: string;
        WorkflowClass4?: string;
        WorkflowClass5?: string;
        InstanceKey1?: string;
        InstanceKey2?: string;
        InstanceKey3?: string;
        InstanceKey4?: string;
        InstanceKey5?: string;
        ViewPermission?: string;
        ApprovePermission?: string;
        RejectPermission?: string;
        SkipPermission?: string;
        FieldList?: QueueField[];
        FieldsJson?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace QueueRow {
        export const idProperty = 'QueueCode';
        export const nameProperty = 'QueueCode';
        export const localTextPrefix = 'Workflow.Queue';
        export const lookupKey = 'Workflow.Queue';

        export function getLookup(): Q.Lookup<QueueRow> {
            return Q.getLookup<QueueRow>('Workflow.Queue');
        }
        export const deletePermission = 'DataAdmin:WorkflowQueue';
        export const insertPermission = 'DataAdmin:WorkflowQueue';
        export const readPermission = 'Read:WorkflowQueue';
        export const updatePermission = 'DataAdmin:WorkflowQueue';

        export declare const enum Fields {
            QueueCode = "QueueCode",
            QueueName = "QueueName",
            QueueTypeCode = "QueueTypeCode",
            StatusCodes = "StatusCodes",
            WorkflowCode = "WorkflowCode",
            WorkflowClass1 = "WorkflowClass1",
            WorkflowClass2 = "WorkflowClass2",
            WorkflowClass3 = "WorkflowClass3",
            WorkflowClass4 = "WorkflowClass4",
            WorkflowClass5 = "WorkflowClass5",
            InstanceKey1 = "InstanceKey1",
            InstanceKey2 = "InstanceKey2",
            InstanceKey3 = "InstanceKey3",
            InstanceKey4 = "InstanceKey4",
            InstanceKey5 = "InstanceKey5",
            ViewPermission = "ViewPermission",
            ApprovePermission = "ApprovePermission",
            RejectPermission = "RejectPermission",
            SkipPermission = "SkipPermission",
            FieldList = "FieldList",
            FieldsJson = "FieldsJson",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
